// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: row;
  gap: 0;
  width: 100%;
  height: 100%;
}

.left-content {
  width: 35%;
  display: flex;
  flex-direction: column;
  background: var(--ion-color-light);
  padding: 40px;
  padding-top: 80px;
  overflow-y: auto;
  height: 100vh;
}
.left-content ion-card {
  margin-bottom: 32px;
}
.left-content ion-card ion-card-header {
  background: #fff;
  border-bottom: 1px solid var(--ion-color-light);
  text-align: left;
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  padding: 20px;
  gap: 10px;
}
.left-content ion-card ion-card-header ion-icon {
  font-size: 20px;
}
.left-content ion-card ion-card-header p {
  font-weight: 600;
  color: var(--ion-color-dark);
  font-size: 15px;
}
.left-content ion-card ion-card-header ion-button {
  margin: 0;
  margin-left: auto;
  height: 20px;
  --padding-end: 0;
  --padding-bottom: 0;
  --padding-top: 0;
  --padding-start: 0;
}
.left-content .order-data ion-grid {
  margin-bottom: -13px;
}
.left-content .order-data ion-card-content {
  padding: 0 16px !important;
}
.left-content .order-data ion-card-content ion-grid {
  padding: 0;
}
.left-content .order-data ion-card-content ion-grid ion-row {
  border-bottom: 1px solid var(--ion-color-light);
}
.left-content .order-data ion-card-content ion-grid ion-row ion-col {
  padding: 16px 0;
  color: var(--ion-color-medium);
}
.left-content .order-data ion-card-content ion-grid ion-row .data-info {
  color: black !important;
}
.left-content .order-data ion-card-content ion-grid ion-row .data-total {
  color: var(--ion-color-primary);
}
.left-content ion-item ion-icon {
  font-size: 27px;
}

.right-content {
  height: 100vh;
  width: 65%;
  display: flex;
  flex-direction: column;
}
.right-content .title {
  padding: 80px 40px;
  padding-bottom: 8px !important;
  margin-bottom: 0 !important;
  text-align: center;
}
.right-content .title h1 {
  font-size: 50px;
  font-weight: 600;
}
.right-content .title p {
  font-size: 20px;
}
.right-content .title ion-button {
  position: absolute;
  top: 0;
  right: 0;
  --border-radius: 50px;
  width: 40px;
  height: 40px;
  --padding-top: 0;
  --padding-bottom: 0;
  --padding-start: 0;
  --padding-end: 0;
  margin: 32px;
}
.right-content .title ion-button ion-icon {
  font-size: 20px;
}
.right-content .options {
  height: 100%;
  padding: 24px;
  padding-bottom: 48px;
  margin: 0;
}
.right-content .options ion-row {
  height: 100%;
}
.right-content .options ion-row ion-col {
  height: 50%;
  padding: 16px;
}
.right-content .options .option {
  width: 100%;
  height: 100%;
  margin: 0;
  border: 1px solid #ebeff8;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: 20px;
  cursor: pointer;
  border-radius: 13px;
}
.right-content .options .option ion-icon {
  font-size: 65px;
  margin-bottom: 40px;
  color: #404248;
}
.right-content .options .option ion-label {
  font-size: 18px !important;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  color: #404248;
  width: 70%;
}
.right-content .options .option--disabled {
  cursor: not-allowed;
}
.right-content .options .option--disabled ion-icon,
.right-content .options .option--disabled ion-label {
  color: #d5dae5;
}

.line {
  height: 100%;
  width: 1px;
  background: #ebeff8;
  margin: 0 16px;
}

.option-disabled {
  cursor: no-drop;
}
.option-disabled ion-icon,
.option-disabled ion-label {
  opacity: 0.6;
}

.others,
.types {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.show-board {
  display: flex !important;
  top: 0;
  left: 0;
  position: absolute;
  opacity: 0.5;
  background: var(--ion-color-dark);
  -webkit-backdrop-filter: blur(50px);
          backdrop-filter: blur(50px);
  z-index: 111111;
  display: flex;
  align-items: center;
  justify-content: center;
}
.show-board h1 {
  color: white;
  text-align: center;
  font-size: 25px;
}

.hide-board {
  display: none;
}

.close-btn {
  display: flex;
  gap: 10px;
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1111;
  --border-radius: 50px !important;
  width: 50px;
  height: 50px;
}
.close-btn ion-icon {
  font-size: 20px !important;
}

.send-mail ion-button {
  position: absolute;
  right: 0;
  --background: transparent !important;
}

@media (max-width: 767px) {
  .container {
    display: block;
  }
  .left-content {
    display: none;
  }
  .right-content {
    width: 100%;
    height: unset !important;
    padding-bottom: env(safe-area-inset-bottom);
    padding-top: calc(env(safe-area-inset-top) + 32px) !important;
  }
  .right-content .title {
    padding: 16px;
    padding-top: 32px;
    padding-bottom: 32px !important;
  }
  .right-content .title h1 {
    font-size: 40px !important;
  }
  .right-content .title p {
    font-size: 16px !important;
  }
  .right-content .options {
    padding: 8px;
  }
  .right-content .options ion-row ion-col {
    padding: 8px;
  }
  .right-content .options .option ion-label {
    font-size: 14px !important;
  }
  .right-content ion-card {
    margin: 16px;
    margin-top: 0;
    border: 1px solid #ebeff8;
  }
  .right-content ion-card ion-card-header {
    background: #fff;
    border-bottom: 1px solid var(--ion-color-light);
    text-align: left;
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 20px;
    gap: 10px;
  }
  .right-content ion-card ion-card-header ion-icon {
    font-size: 20px;
  }
  .right-content ion-card ion-card-header p {
    font-weight: 600;
    color: var(--ion-color-dark);
    font-size: 15px;
  }
  .right-content ion-card ion-card-header ion-button {
    margin: 0;
    margin-left: auto;
    height: 20px;
    --padding-end: 0;
    --padding-bottom: 0;
    --padding-top: 0;
    --padding-start: 0;
  }
  .close-btn {
    --background: #ebeef1;
    --background-hover: #ebeef1;
    --background-activated: #ebeef1;
    top: env(safe-area-inset-top) !important;
    right: 16px !important;
    position: fixed;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/payments/success-payment/success-payment.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,aAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EACE,gBAAA;EACA,+CAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,aAAA;EACA,SAAA;AACN;AACM;EACE,eAAA;AACR;AAEM;EACE,gBAAA;EACA,4BAAA;EACA,eAAA;AAAR;AAGM;EACE,SAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AADR;AAOI;EACE,oBAAA;AALN;AAQI;EACE,0BAAA;AANN;AAQM;EACE,UAAA;AANR;AAQQ;EACE,+CAAA;AANV;AAQU;EACE,eAAA;EACA,8BAAA;AANZ;AASU;EACE,uBAAA;AAPZ;AAUU;EACE,+BAAA;AARZ;AAgBI;EACE,eAAA;AAdN;;AAmBA;EACE,aAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AAhBF;AAkBE;EACE,kBAAA;EACA,8BAAA;EACA,2BAAA;EACA,kBAAA;AAhBJ;AAkBI;EACE,eAAA;EACA,gBAAA;AAhBN;AAmBI;EACE,eAAA;AAjBN;AAoBI;EACE,kBAAA;EACA,MAAA;EACA,QAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;AAlBN;AAoBM;EACE,eAAA;AAlBR;AAuBE;EACE,YAAA;EACA,aAAA;EACA,oBAAA;EACA,SAAA;AArBJ;AAuBI;EACE,YAAA;AArBN;AAuBM;EACE,WAAA;EACA,aAAA;AArBR;AAyBI;EACE,WAAA;EACA,YAAA;EACA,SAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;AAvBN;AAyBM;EACE,eAAA;EACA,mBAAA;EACA,cAAA;AAvBR;AA0BM;EACE,0BAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AAxBR;AA2BM;EACE,mBAAA;AAzBR;AA2BQ;;EAEE,cAAA;AAzBV;;AAgCA;EACE,YAAA;EACA,UAAA;EACA,mBAAA;EACA,cAAA;AA7BF;;AAgCA;EACE,eAAA;AA7BF;AA+BE;;EAEE,YAAA;AA7BJ;;AAiCA;;EAEE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AA9BF;;AAiCA;EACE,wBAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,iCAAA;EACA,mCAAA;UAAA,2BAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AA9BF;AAgCE;EACE,YAAA;EACA,kBAAA;EACA,eAAA;AA9BJ;;AAkCA;EACE,aAAA;AA/BF;;AAkCA;EACE,aAAA;EACA,SAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;AA/BF;AAiCE;EACE,0BAAA;AA/BJ;;AAoCE;EACE,kBAAA;EACA,QAAA;EACA,oCAAA;AAjCJ;;AAqCA;EACE;IACE,cAAA;EAlCF;EAqCA;IACE,aAAA;EAnCF;EAsCA;IACE,WAAA;IACA,wBAAA;IACA,2CAAA;IACA,6DAAA;EApCF;EAsCE;IACE,aAAA;IACA,iBAAA;IACA,+BAAA;EApCJ;EAsCI;IACE,0BAAA;EApCN;EAuCI;IACE,0BAAA;EArCN;EAyCE;IACE,YAAA;EAvCJ;EA0CM;IACE,YAAA;EAxCR;EA6CM;IACE,0BAAA;EA3CR;EAgDE;IACE,YAAA;IACA,aAAA;IACA,yBAAA;EA9CJ;EAgDI;IACE,gBAAA;IACA,+CAAA;IACA,gBAAA;IACA,aAAA;IACA,mBAAA;IACA,eAAA;IACA,aAAA;IACA,SAAA;EA9CN;EAgDM;IACE,eAAA;EA9CR;EAiDM;IACE,gBAAA;IACA,4BAAA;IACA,eAAA;EA/CR;EAkDM;IACE,SAAA;IACA,iBAAA;IACA,YAAA;IACA,gBAAA;IACA,mBAAA;IACA,gBAAA;IACA,kBAAA;EAhDR;EAsDA;IACE,qBAAA;IACA,2BAAA;IACA,+BAAA;IACA,wCAAA;IACA,sBAAA;IACA,eAAA;EApDF;AACF","sourcesContent":[".container {\n  display: flex;\n  flex-direction: row;\n  gap: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.left-content {\n  width: 35%;\n  display: flex;\n  flex-direction: column;\n  background: var(--ion-color-light);\n  padding: 40px;\n  padding-top: 80px;\n  overflow-y: auto;\n  height: 100vh;\n\n  ion-card {\n    margin-bottom: 32px;\n\n    ion-card-header {\n      background: #fff;\n      border-bottom: 1px solid var(--ion-color-light);\n      text-align: left;\n      display: flex;\n      flex-direction: row;\n      align-items: center;\n      cursor: pointer;\n      padding: 20px;\n      gap: 10px;\n\n      ion-icon {\n        font-size: 20px;\n      }\n\n      p {\n        font-weight: 600;\n        color: var(--ion-color-dark);\n        font-size: 15px;\n      }\n\n      ion-button {\n        margin: 0;\n        margin-left: auto;\n        height: 20px;\n        --padding-end: 0;\n        --padding-bottom: 0;\n        --padding-top: 0;\n        --padding-start: 0;\n      }\n    }\n  }\n\n  .order-data {\n    ion-grid {\n      margin-bottom: -13px;\n    }\n\n    ion-card-content {\n      padding: 0 16px !important;\n\n      ion-grid {\n        padding: 0;\n\n        ion-row {\n          border-bottom: 1px solid var(--ion-color-light);\n\n          ion-col {\n            padding: 16px 0;\n            color: var(--ion-color-medium);\n          }\n\n          .data-info {\n            color: black !important;\n          }\n\n          .data-total {\n            color: var(--ion-color-primary);\n          }\n        }\n      }\n    }\n  }\n\n  ion-item {\n    ion-icon {\n      font-size: 27px;\n    }\n  }\n}\n\n.right-content {\n  height: 100vh;\n  width: 65%;\n  display: flex;\n  flex-direction: column;\n\n  .title {\n    padding: 80px 40px;\n    padding-bottom: 8px !important;\n    margin-bottom: 0 !important;\n    text-align: center;\n\n    h1 {\n      font-size: 50px;\n      font-weight: 600;\n    }\n\n    p {\n      font-size: 20px;\n    }\n\n    ion-button {\n      position: absolute;\n      top: 0;\n      right: 0;\n      --border-radius: 50px;\n      width: 40px;\n      height: 40px;\n      --padding-top: 0;\n      --padding-bottom: 0;\n      --padding-start: 0;\n      --padding-end: 0;\n      margin: 32px;\n\n      ion-icon {\n        font-size: 20px;\n      }\n    }\n  }\n\n  .options {\n    height: 100%;\n    padding: 24px;\n    padding-bottom: 48px;\n    margin: 0;\n\n    ion-row {\n      height: 100%;\n\n      ion-col {\n        height: 50%;\n        padding: 16px;\n      }\n    }\n\n    .option {\n      width: 100%;\n      height: 100%;\n      margin: 0;\n      border: 1px solid #ebeff8;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      justify-content: center;\n      height: 100%;\n      width: 100%;\n      padding: 20px;\n      cursor: pointer;\n      border-radius: 13px;\n\n      ion-icon {\n        font-size: 65px;\n        margin-bottom: 40px;\n        color: #404248;\n      }\n\n      ion-label {\n        font-size: 18px !important;\n        font-weight: 600;\n        text-transform: uppercase;\n        text-align: center;\n        color: #404248;\n        width: 70%;\n      }\n\n      &--disabled {\n        cursor: not-allowed;\n\n        ion-icon,\n        ion-label {\n          color: #d5dae5;\n        }\n      }\n    }\n  }\n}\n\n.line {\n  height: 100%;\n  width: 1px;\n  background: #ebeff8;\n  margin: 0 16px;\n}\n\n.option-disabled {\n  cursor: no-drop;\n\n  ion-icon,\n  ion-label {\n    opacity: 0.6;\n  }\n}\n\n.others,\n.types {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.show-board {\n  display: flex !important;\n  top: 0;\n  left: 0;\n  position: absolute;\n  opacity: 0.5;\n  background: var(--ion-color-dark);\n  backdrop-filter: blur(50px);\n  z-index: 111111;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  h1 {\n    color: white;\n    text-align: center;\n    font-size: 25px;\n  }\n}\n\n.hide-board {\n  display: none;\n}\n\n.close-btn {\n  display: flex;\n  gap: 10px;\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  z-index: 1111;\n  --border-radius: 50px !important;\n  width: 50px;\n  height: 50px;\n\n  ion-icon {\n    font-size: 20px !important;\n  }\n}\n\n.send-mail {\n  ion-button {\n    position: absolute;\n    right: 0;\n    --background: transparent !important;\n  }\n}\n\n@media (max-width: 767px) {\n  .container {\n    display: block;\n  }\n\n  .left-content {\n    display: none;\n  }\n\n  .right-content {\n    width: 100%;\n    height: unset !important;\n    padding-bottom: env(safe-area-inset-bottom);\n    padding-top: calc(env(safe-area-inset-top) + 32px) !important;\n\n    .title {\n      padding: 16px;\n      padding-top: 32px;\n      padding-bottom: 32px !important;\n\n      h1 {\n        font-size: 40px !important;\n      }\n\n      p {\n        font-size: 16px !important;\n      }\n    }\n\n    .options {\n      padding: 8px;\n\n      ion-row {\n        ion-col {\n          padding: 8px;\n        }\n      }\n\n      .option {\n        ion-label {\n          font-size: 14px !important;\n        }\n      }\n    }\n\n    ion-card {\n      margin: 16px;\n      margin-top: 0;\n      border: 1px solid #ebeff8;\n\n      ion-card-header {\n        background: #fff;\n        border-bottom: 1px solid var(--ion-color-light);\n        text-align: left;\n        display: flex;\n        align-items: center;\n        cursor: pointer;\n        padding: 20px;\n        gap: 10px;\n\n        ion-icon {\n          font-size: 20px;\n        }\n\n        p {\n          font-weight: 600;\n          color: var(--ion-color-dark);\n          font-size: 15px;\n        }\n\n        ion-button {\n          margin: 0;\n          margin-left: auto;\n          height: 20px;\n          --padding-end: 0;\n          --padding-bottom: 0;\n          --padding-top: 0;\n          --padding-start: 0;\n        }\n      }\n    }\n  }\n\n  .close-btn {\n    --background: #ebeef1;\n    --background-hover: #ebeef1;\n    --background-activated: #ebeef1;\n    top: env(safe-area-inset-top) !important;\n    right: 16px !important;\n    position: fixed;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
